/**
 * P15 — relay de mensagens postadas pelo SW pro PostHog (browser SDK).
 *
 * PostHog SDK roda no contexto `window` (depende de `document`); não roda
 * em SW worker context. SW envia postMessage pro client, client dispara
 * `posthog.capture()`. Função pura pra facilitar unit test.
 */

export type CaptureFn = (event: string, props?: Record<string, unknown>) => void;

type SwMessageEvent = { data?: { type?: string; version?: string } };

export function handleSwMessage(event: SwMessageEvent, capture: CaptureFn): void {
  const data = event.data;
  if (data?.type !== 'sw-installed') return;
  if (typeof data.version !== 'string') return;
  capture('sw_version_installed', { version: data.version });
}
